import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/numbers";

const { actions, types } = createActions({
  addNumber: ["number", "onSuccess", "onFailure"],
  updateNumber: ["id", "number", "onSuccess", "onFailure"],
  setLoading: ["loading"],
  fetchNumberRequest: ["page", "perPage", "onFailure"],
  exportNumberRequest: ["page", "perPage", "onSuccess", "onFailure"],
  setInitialFetchIsDone: [],
  setNumberTotalItems: ["totalItems"],
  setNumberPerPage: ["perPage"],
  setNumberPage: ["page"],
  addNumbers: ["numbers"],
  setNumberQs: ["qs"],

  fetchLocationRequest: ["onFailure"],
  addLocations: ["locations"],

  fetchTimezoneRequest: ["onFailure"],
  addTimezone: ["timezones"],

  fetchPayGroupsRequest: ["onFailure"],
  addPayGroups: ["locations"],
});

const reducer = createReducer(initialState, {
  [types.ADD_NUMBERS]: (state, { payload }) => ({
    ...state,
    numbers: [...payload.numbers],
  }),
  [types.ADD_LOCATIONS]: (state, { payload }) => ({
    ...state,
    locations: [...payload.locations],
  }),
  [types.ADD_PAY_GROUPS]: (state, { payload }) => ({
    ...state,
    payGroups: [...payload.payGroups],
  }),
  [types.ADD_TIMEZONE]: (state, { payload }) => ({
    ...state,
    timezones: [...payload.timezones],
  }),
  [types.SET_LOADING]: (state, { payload }) => ({
    ...state,
    loading: payload.loading,
  }),
  [types.SET_INITIAL_FETCH_IS_DONE]: (state) => ({
    ...state,
    initialFetchIsDone: true,
  }),
  [types.SET_NUMBER_TOTAL_ITEMS]: (state, { payload }) => ({
    ...state,
    totalItems: payload.totalItems,
  }),
  [types.SET_NUMBER_PAGE]: (state, { payload }) => ({
    ...state,
    page: payload.page,
  }),
  [types.SET_NUMBER_PER_PAGE]: (state, { payload }) => ({
    ...state,
    perPage: payload.perPage,
  }),
  [types.SET_NUMBER_QS]: (state, { payload }) => ({
    ...state,
    qs: payload.qs,
    page: 0,
  }),
});

export { reducer as default, types, actions };
